export const bps = {
    greaterThanMobile: '@media screen and (min-width: 880px)',
    smallerThanDesktop: '@media only screen and (max-width: 600px)'
}

export const theme = {
    colors: {
        primary: 'var(--theme-primary-color)',
        secondary: 'var(--theme-secondary-color)',

    },
    buttons: {
        primary: 'var(--theme-button-color)'
    },
    header: {
        primary: 'var(--theme-secondary-color)'
    }

}